import React from 'react'

import Link from '../../Link'
import { FooterLegalFootnotes } from '../FooterLegalFootnotes'
import { SocialMediaMenu } from '../SocialMediaMenu'
import * as Styled from './styled'

import logo from '../../../../img/logo-designs-for-health-textonly.svg'

export const FooterPrint: React.FC = () => (
  <Styled.FooterContainer $printable>
    <Styled.LogoAndSocialLinksContainer>
      <Styled.Row>
        <Styled.Logo>
          <Link to="/">
            <img src={logo} alt="Designs for Health" />
          </Link>
        </Styled.Logo>
        <Styled.SocialMediaLinks>
          <SocialMediaMenu />
        </Styled.SocialMediaLinks>
      </Styled.Row>
    </Styled.LogoAndSocialLinksContainer>
    <Styled.LegalContainer>
      <Styled.LegalBlock>
        <FooterLegalFootnotes />
      </Styled.LegalBlock>
    </Styled.LegalContainer>
  </Styled.FooterContainer>
)
